import * as React from 'react';

function SvgListBullets(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M11 8h16M11 16h16M11 24h16"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5.5 17.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5.5 25.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgListBullets;
